module.exports = __webpack_public_path__ + "media/en.05378086.mp3";